
import AbsoluteUrlUtil from "./AbsoluteUrlUtil";

/**
 * バックエンドでurl mappingしているページのURLを組み立てるクラス
 */
export default class ServletUrlUtil extends AbsoluteUrlUtil {
    /**
     * ベース課金ページへのURLを返す.
     */
    paymentBaseUrl = () => "/web/payment";

    /**
     * 有料会員解約ページへのURLを返す.
     */
    paymentCancelUrl = () => "/web/payment/cancel"

    /**
     * OIDC ログインページへのURLを返す.
     * 旧: /sp/account/carrier_auth
     */
    registrationUrl = () => "/web/auth/oidc/login";

    /**
     * マイページへのURLを返す.
     */
    myPageUrl = () => "/sp/2/mypage/#/puri/new";


    /**
     * プリGETページのurl
     * ゲスト、もしくはミニ&証明プリの場合はLPへ
     * それ以外はプリGET完了へ
     * @param  {Membership} membership accountStatusに含まれるmembership
     * @param  {String} sealId シールId
     * @param  {Boolean} isProof 証明プリかどうか
     */
    puriGetUrl = (membership, sealId, isProof) => {
        if (membership.isGuest || (membership.isMini && isProof)) {
            return `/sp/puri/get?sealId=${sealId}&from=inputSealId`
        } else {
            return `/web/mypage?sealId=${sealId}&from=inputSealId`
        }
    };

    /**
     * 削除したプリを再度保存させるページのurlを組み立てる
     * (ただのプリGETページだが削除関係のものを依存させたくないのであえて名前をつけている)
     *
     * @param {number} sealId 削除プリに紐づくsealId
     */
    resavePuriUrl = (sealId) => `/web/mypage?sealId=${sealId}`;

    /**
     * 設定ページのURL
     */
    settingUrl = () => "/sp/setting/userinfo";

    /**
     * クーポン一覧ページのURL
     */
    couponUrl = () => "/sp/2/coupon/tickets";

    /**
     * プリ機の特徴からさがすページへのURLを返す.
     */
    machineSearchUrl = () => `/sp/2/machines/search`;

    /**
     * ペナルティについての説明ページへのURLを返す.
     */
    penaltyDetailUrl = () => `/sp/common/aboutPenalty`;

    /**
     * ログインページへのURLを返す.
     */
    loginUrl = () => `/web/login/top`;

    /**
     * かんたんログイン失敗ページへのURLを返す.
     */
    loginFailedUrl = () => `/web/login/fail`;

    /**
     * ピクトリンクお問い合わせページへのURLを返す.（pictlink-webへ移行済み）
     */
    inquiryUrl = () => `/web/common/inquiry`;

    /**
     * ピクトリンクお問い合わせの指定カテゴリーの入力フォームページへのURLを返す.（pictlink-webへ移行済み）
     * @param category {string}
     */
    inquiryInputUrl = (category) => `/web/common/inquiry/input/` + category

    /**
     * プリお問い合わせページへのURLを返す.（pictlink-webへ移行済み）
     */
    inquiryPuriUrl = () => `/web/common/inquiry_puri`;

    /**
     * ピクトリンクフォトお問い合わせページへのURLを返す.（pictlink-webへ移行済み）
     */
    pictlinkPhotosInquiryUrl = () => "/web/common/inquiry_pictlink_photos/input";

    /**
     * (ログイン時の)トップページへのURLを返す.
     */
    topUrl = () => `/web/top`;

    /**
     * MINIからPREMIUMになるときのキャリア等の課金ページへのURL
     * @param paymentKind {string}
     */
    paymentUrlForMiniToPremium = (paymentKind) => {
        switch (paymentKind) {
            case 'ezweb':
                return '/sp/auoneadmit/admittop';
            case 'docomo':
                return '/sp/2/docomo_payment/subscribe/top';
            case 'softbank':
                return '/sp/softbankadmit/admittop';
            case 'credit':
                return '/web/payment/credit';
            default:
                return null;
        }
    };

    /**
     * MINIからお試し登録するときのauお試し登録処理開始URL
     */
    paymentTrialStartUrlForMiniToPremium = () => '/sp/auoneadmit/au_trial_start';

    /**
     * ログインしていない人向けの有料会員解約案内ページへのURL
     * 通常の有料会員解約案内ページとは異なる
     */
    withdrawalForGuestUrl = () => `/sp/paymentid_withdrawal/top`;

    /**
     * 筐体一覧へのURL
     */
    machineListUrl = (isIdFederationSupported) => `/web/machines/information${isIdFederationSupported ? '?isIdFederationSupported=true' : ''}`;

    /**
     * 筐体紹介ページへのURL
     */
    machinePagetUrl = (id) => {
        if (id == 1001) {
            // 証明プリLP はweb 移行済なのでweb のURL を返す
            return `/web/machine/${id}`
        }
        return `/sp/machine/${id}`
    };

    /**
     * DOCOMOの認証URL
     */
    docomoAuthUrl = (onSuccessUrl, onFailureUrl) => {
        const onSuccessAbsoluteUrl = this.buildPictlinkAbsoluteUrl(onSuccessUrl);
        const onFailureAbsoluteUrl = this.buildPictlinkAbsoluteUrl(onFailureUrl);
        return `${this.buildPictlinkAuth('/api/v1/authn/docomo')}?onSuccess=${onSuccessAbsoluteUrl}&onFailure=${onFailureAbsoluteUrl}`;
    }

    /**
     * auの認証URL
     */
    auAuthUrl = (onSuccessUrl, onFailureUrl) => {
        const onSuccessAbsoluteUrl = this.buildPictlinkAbsoluteUrl(onSuccessUrl);
        const onFailureAbsoluteUrl = this.buildPictlinkAbsoluteUrl(onFailureUrl);
        return `${this.buildPictlinkAuth('/api/v1/authn/au/auoneid')}?onSuccess=${onSuccessAbsoluteUrl}&onFailure=${onFailureAbsoluteUrl}`;
    }

    /**
     * softBankの認証URL
     */
    softBankAuthUrl = (onSuccessUrl, onFailureUrl) => {
        const onSuccessAbsoluteUrl = this.buildPictlinkAbsoluteUrl(onSuccessUrl);
        const onFailureAbsoluteUrl = this.buildPictlinkAbsoluteUrl(onFailureUrl);
        return `${this.buildPictlinkAuth('/api/v1/authn/softbank')}?onSuccess=${onSuccessAbsoluteUrl}&onFailure=${onFailureAbsoluteUrl}`;
    }

    /**
     * LINEログインのベースURL
     */
    lineLoginBaseUrl = () => {
        return '/sp/2/login/line/pictlinkauth'
    }

    /**
     * LINEの認証URL
     */
    lineAuthUrl = (onSuccessPath, onFailurePath, redirectUri) => {
        const onSuccessBase = this._appendRedirectUri(onSuccessPath, redirectUri)
        const onSuccessAbsoluteUrl = this.buildPictlinkAbsoluteUrl(onSuccessBase);
        const onFailureAbsoluteUrl = this.buildPictlinkAbsoluteUrl(onFailurePath);
        return `${this.buildPictlinkAuth('/api/v1/authn/line')}?onSuccess=${onSuccessAbsoluteUrl}&onFailure=${onFailureAbsoluteUrl}`;
    }

    /**
     * @private
     * @param path redirectUriを付与するPath。独自のquery paramがあってもOK. e.g. /sp/account/login, /sp/puri/get?sealId=xxx
     * @param redirectUri pathに付与されるredirectUri.
     */
    _appendRedirectUri = (path, redirectUri) => {
        if (!redirectUri) {
            return path;
        }
        const url = new URL(path, location.origin);
        const searchParams = url.searchParams;
        searchParams.set("redirectUri", redirectUri);
        return `${url.pathname}${url.search}`
    }


    /**
     * twitterでログインのURL
     */
    twitterLoginUrl = () => {
        const onSuccess = this.buildPictlinkAbsoluteUrl('/sp/2/login/twitter/pictlinkauth');
        const onFailure = this.buildPictlinkAbsoluteUrl('/web/login/fail');
        return `${this.buildPictlinkAuth('/api/v1/authn/twitter')}?onSuccess=${onSuccess}&onFailure=${onFailure}`;
    }


    /**
     * [中学生ピクトリンク無料サービス]申込情報入力ページへのURL
     */
    inputProfileUrl = () => `/sp/jhs_free#/input/profile`;

    /**
     * [中学生ピクトリンク無料サービス]LPのURL
     */
    jhsFreeLpUrl = (parameter) => `/sp/jhs_free?from=${parameter}#/lp`

    /**
     * プリニュースのURL
     * @param id {String} WordPressの記事ID
     * @param parameter {String} fromパラメーター.
     */
    puriNewsUrl = (id, parameter) => `/sp/puri_news?from=${parameter}#/${id}`

    /**
     * 「遊べるお店はこちら」ページのURL
     * @param machineName {String} 筐体名
     */
    shopSearchUrl = (machineName) => `https://map.pictlink.com/?machine=${machineName}`

    veritransPremiumWithdrawalUrl = () => '/sp/2/payment/veritrans/credit/withdraw';

    auPaymentPremiumWithdrawalUrl = () => '/sp/auonewithdrawal/withdrawal';
    auPaymentShiftWithdrawalUrl = () => '/sp/auonewithdrawal/shiftWithdrawal'

    spmodePremiumWithdrawalUrl = () => '/sp/spmodeclient/normal_withdrawal';
    spmodeShiftWithdrawalUrl = () => '/sp/spmodeclient/shift_withdrawal'

    docomoPaymentWithdrawalUrl = () => '/sp/2/docomo_payment/unsubscribe/start'
}
